import {
  ProductSubType,
  ProgramScheduleDTO,
} from "@campgladiator/cg-common.types.types";

export const filterProgramScheduleByProductSubType = (
  programSchedules: ProgramScheduleDTO[],
  productSubType: ProductSubType
) => {
  return programSchedules?.filter((schedule) => {
    switch (productSubType) {
      case "IN_PERSON":
        return (
          schedule.approvalRequired === "ONLINE" ||
          schedule.approvalRequired === "OUTDOOR"
        );
      case "ONLINE":
        return schedule.approvalRequired === "ONLINE";
      default:
        return false;
    }
  });
};
